import {Component, OnInit, ViewChild} from '@angular/core';
import {UserForm} from '../models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {GlobalVariable} from '../../../../app/config';
import {AdminService} from '../services/admin.service';
import {Router, ActivatedRoute} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-admin-crud',
  templateUrl: '../views/admin-crud.component.html',
  styleUrls: ['../css/admin-crud.component.css'],
  providers: [GlobalDataService]
})
export class AdminCrudComponent implements OnInit {

  public userObj = new UserForm('', '', '', '', true, '', true, null, [], {});
  public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
  public timezonelist: any;
  public roleList: any;
  public dealerList: any;
  public regionList: any;
  public selectedRegions: any = [];
  public selectedDealers: any = [];
  public dealers = [];
  public responseMessage = '';
  public selectedRoles: any = [];
  public userId: any;
  public dealerTodisplay: any;
  public selectAll = false;
  public allDealer: any;
  public emailExist: boolean = false;
  public showIcon: boolean = false;
  public spinnerIcon: boolean = false;
  public showmessage: boolean = false
  submitted: boolean = false
  public showRegion: boolean = false
  public roleValues = ""
  public regionSelect: any = []
  public newRegions: any = []
  public regionSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'code',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  @ViewChild('userForm') userFormObj: any;

  constructor(private _dataService: GlobalDataService, private _adminService: AdminService, private _router: Router, public activeroute: ActivatedRoute) {

  }

  ngOnInit() {
    if (sessionStorage.getItem('roleId') !== "SYSADM" && sessionStorage.getItem('roleId') !== "SUSER" ) {
      //console.log(sessionStorage.getItem('roleId'))
      this._router.navigate(['dashboard'])
    }
    this.getRoleList();
    this.getTimezonelist();
    this.getDealerList();
    this.getRegionList();

    this.activeroute.params.subscribe(
      params => {
        if (Object.keys(params).length != 0) {
          this.userId = params.id;
          this.getUserDeatails();
          this.userObj.id = this.userId
        }
      });

  }

  /**
   * @author Anand Singh
   * @uses    Save/Edit user
   */
  saveUser() {
    if (this.userObj['dealers'].length == 0) {
      this.showmessage = true
    } else {
      this.responseMessage = '';
      this.userObj['id'] = this.userId; // edit id
      // this.userObj['userId']= Number(localStorage.getItem('userId')); // login id
      this.userObj['userId'] = Number(sessionStorage.getItem('userId')); // login id
      this.userObj['dealers'] = this.selectedDealers;
      this.userObj.caseNotification = (this.userObj.leadNotification);
//        console.log("this.userObj"+JSON.stringify(this.userObj))
      this._adminService.saveUser(this.userObj, (result) => {
        if (result.statusCodes == 'USER_SAVED_SUCCESSFULLY') {
          this.responseMessage = 'SUCCESS';
          this.userId = result.id;
          setTimeout(() => {
            if (this.userId != "" && this.userId != undefined) {
              this._router.navigate(['admin/detail/' + this.userId]);
            } else {
              this._router.navigate(['admin']);
            }
            //this._router.navigate(['admin']);
          }, 2000);
        } else
          this.responseMessage = 'FAILURE';
      })
    }
  }

  /**
   * @author Anand Singh
   * @uses get the timezone list
   */
  getTimezonelist() {
    this._adminService.getTimezonelist((result) => {
      this.timezonelist = result;
    })
  }

  /**
   * @author Anand
   * @uses    Get user roles
   */
  getRoleList() {
    this._adminService.getUserRoles((result) => {
      this.roleList = result;

    })
  }


  /**
   * @author Anand
   * @uses    Get user dealer
   */
  getDealerList() {
    this._adminService.getUserDealer((result) => {
      this.dealerList = result;
      this.dealerList = this.dealerList.sort((a,b) => (a.superDealerCode > b.superDealerCode) ? 1 : ((b.superDealerCode > a.superDealerCode) ? -1 : 0));

      this.dealerTodisplay = result;
      this.dealerTodisplay = this.dealerTodisplay.sort((a,b) => (a.superDealerCode > b.superDealerCode) ? 1 : ((b.superDealerCode > a.superDealerCode) ? -1 : 0));

      //console.log(result);
    })
  }


  /**
   * @author Anand
   * @uses    Get region list
   */
  getRegionList() {
    this._adminService.getRegionList((result) => {
      this.regionList = result;
    })
  }

  /**
   * @author Anand
   * @uses    Select regions
   */

  selectRegion(region) {

    if (!this.selectedRegions.includes(region.code)) {
      const dealer = this.filterDealer(this.dealerList, 'regionCode', region.code, 'add');
      if (this.selectedRegions.length == 0) {

        this.dealerTodisplay = this.arrayUnique(dealer);
        if (this.roleValues == "REGIONAL") {
          this.selectedDealers = this.arrayUnique(dealer);
        }
      } else {

        this.dealerTodisplay = this.dealerTodisplay.concat(dealer);

        if (this.roleValues == "REGIONAL") {
          this.selectedDealers = this.dealerTodisplay
        }
      }
      this.selectedRegions.push(region.code);

    } else {

      const index: number = this.selectedRegions.indexOf(region.code);
      this.selectedRegions.splice(index, 1);
      this.dealerTodisplay = this.filterDealer(this.dealerTodisplay, 'regionCode', region.code, 'remove');
      if (this.dealerTodisplay.length == 0) {
        this.dealerTodisplay = this.dealerList
      } else {
        if (this.roleValues == "REGIONAL") {
          this.selectedDealers = this.dealerTodisplay

        }

      }

    }

    (this.dealerTodisplay.length == this.selectedDealers.length) ? this.selectAll = true : this.selectAll = false;

  }

  /**
   * @author Anand
   * @uses   Select dealers
   */

  selectDealer(dealer) {
    if (this.roleValues == "REGIONAL" && this.allDealer == undefined) {
      if (!this.dealers.includes(dealer.id)) {
        const index: number = this.dealers.indexOf(dealer.id);
        this.dealers.splice(index, 1);
        this.selectedDealers.splice(index, 1);
      } else {
        this.dealers.push(dealer.id);
        this.selectedDealers.push(dealer);
      }
    } else {
      if (!this.dealers.includes(dealer.id)) {
        this.dealers.push(dealer.id);
        this.selectedDealers.push(dealer);
      } else {
        const index: number = this.dealers.indexOf(dealer.id);
        this.dealers.splice(index, 1);
        this.selectedDealers.splice(index, 1);
      }
    }
    (this.dealerTodisplay.length == this.selectedDealers.length) ? this.selectAll = true : this.selectAll = false;

  }

  /**
   * @author Anand
   * @uses   Select multiple dealers
   */
  selectMultiDealer() {

    if (!this.selectAll) {
      this.dealerTodisplay.forEach((value) => {
        this.selectAll = true;
        if (!this.dealers.includes(value.id)) {
          this.dealers.push(value.id);
          this.selectedDealers.push(value);
        }
      })
    } else {
      this.selectAll = false;
      this.dealers = [];
      this.selectedDealers = [];
    }
//    (this.dealerTodisplay.length==this.selectedDealers.length)?this.selectAll=true:this.selectAll=false;
  }

  /**
   * @author Anand
   * @uses show prefrences
   */
  showPrefrences(roleObj) {
    if (roleObj.id == 2) {
      this.showRegion = true
    } else {
      this.showRegion = false
    }
    this.roleValues = roleObj.code

    this.selectedRoles = [];
        //console.log("roleObj"+JSON.stringify(roleObj))
        //console.log("roleObj2"+JSON.stringify(this.selectedRoles))
    if (roleObj && roleObj.privileges != null) {
      roleObj.privileges.forEach((val) => {
        if (val.moduleKey == 'ADHOC' && val.privilege != 'NONE') {
          this.selectedRoles.push('ADHOC');
//                 console.log("adhoc")

        }
        if (val.moduleKey == 'LEAD' && val.privilege != 'NONE') {
          this.selectedRoles.push('LEAD');
        }
        if (val.moduleKey == 'CASE' && val.privilege != 'NONE') {
          this.selectedRoles.push('CASE');
        }
        if (val.moduleKey == 'OWNER' && val.privilege != 'NONE') {
          this.selectedRoles.push('OWNER');
        }
      })
    }
  }


  /**
   * @author Anand Singh
   * @uses   Get user detail by ID
   */
  getUserDeatails() {
    this._adminService.getUserRoles((res) => {
      this.roleList = res;

      const thisObj = this;
      this._adminService.getAdminDetails(this.userId, (result) => {
        this.userObj = result;

        this.allDealer = result.dealers;
        if (result.roleId != null) {
          setTimeout(function () {

            thisObj.userObj.roleId = thisObj.roleList.find(function (item) {
              return item.id == result.roleId.id
            });
            thisObj.regionSelect = []

            thisObj.regionSelect = Array.from(new Set(thisObj.allDealer.map((item: any) =>
              item.regionCode
            )))

            thisObj.showPrefrences(thisObj.userObj.roleId);

          }, 1000);
          this.resetDealer();
        }

      })

    })


  }

  /**
   * @author Anand
   * @uses   filter dealer based on attr
   */

  filterDealer(objects: any[], attr: string, val: any, action: string): any {
    if (objects) {
      if (action == 'add') {
        return objects.filter(object => {
          return object[attr] === val;
        });
      } else {
        return objects.filter(object => {
          return object[attr] != val;
        });
      }


    }
  }

  /**
   * @author Anand
   * @uses remove duplicates value from array.
   */
  arrayUnique(array) {
    let a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id)
          a.splice(j--, 1);
      }
    }

    return a;
  }

  /**
   * @author Anand
   * @uses Reset Dealers
   */

  resetDealer() {
    let thisObj = this;
    this.dealers = [];
    this.dealerTodisplay = this.dealerList
    this.selectedDealers = [];
    if (this.allDealer != null) {
      this.allDealer.forEach((val) => {
        thisObj.selectDealer(val);
      })
    }

    (this.dealerTodisplay.length == this.selectedDealers.length) ? this.selectAll = true : this.selectAll = false;
  }

  assignDealer() {
    this.userObj['dealers'] = this.selectedDealers;
    if (this.userObj['dealers'].length == 0) {
      this.showmessage = true
    } else {
      this.showmessage = false
    }
  }

  /**
   * @author Sowmya
   * @description cancel create or edit
   */
  cancel() {
    if (this.userId != "" && this.userId != undefined) {
      this._router.navigate(['admin/detail/' + this.userId]);
    } else {
      this._router.navigate(['admin']);
    }
  }

  /**
   * @author Anand
   * @description Verify email is exist or not
   */
  verifyEmail(userId, email) {
    if (email != '') {
      this.showIcon = true;
      this.spinnerIcon = true;
      this.emailExist = false;
      this._adminService.verifyEmail(userId, email, (res) => {
        this.spinnerIcon = false;
        this.emailExist = !!res;
      })
    } else {
      this.showIcon = false;
    }

  }

  onRegionSelect(value) {
    this.selectRegion(value)
  }

  onRegionDeSelect(value) {
    this.selectRegion(value)
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/admin-crud.component.ts